/**
 * @generated SignedSource<<285807798c7d3595a94004a03092739f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FormMetadataStyleEnum = "ImageCenter" | "ImageLeft" | "NoImage";
export type FormMetadataTemplateEnum = "Basic" | "CompanyLong" | "CompanyShort" | "PasswordProtected" | "PasswordProtectedShort";
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type StatusUiPermissionEnum = "PUBLIC" | "RESTRICTED";
import { FragmentRefs } from "relay-runtime";
export type Znglist_Fragment$data = {
  readonly author: {
    readonly node: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly slug: string | null | undefined;
      readonly username: string | null | undefined;
    };
  } | null | undefined;
  readonly id: string;
  readonly link: string | null | undefined;
  readonly slug: string | null | undefined;
  readonly status: string | null | undefined;
  readonly statusSettings: {
    readonly approved: {
      readonly id: string | null | undefined;
      readonly timestamp: string | null | undefined;
      readonly user: {
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly stateWhenApproved: {
      readonly status: PostStatusEnum | null | undefined;
      readonly uiPermission: {
        readonly type: StatusUiPermissionEnum | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly status: PostStatusEnum | null | undefined;
    readonly uiPermission: {
      readonly type: StatusUiPermissionEnum | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly title: string | null | undefined;
  readonly znglist: {
    readonly form: {
      readonly node: {
        readonly content: string | null | undefined;
        readonly id: string;
        readonly imageUrl: string | null | undefined;
        readonly marketingConsent: boolean | null | undefined;
        readonly metadata: {
          readonly cookieExpiration: string | null | undefined;
          readonly formStyle: FormMetadataStyleEnum | null | undefined;
          readonly formTemplate: FormMetadataTemplateEnum | null | undefined;
          readonly submitSuccessText: string | null | undefined;
        } | null | undefined;
        readonly password: boolean | null | undefined;
        readonly schema: string | null | undefined;
        readonly title: string;
        readonly uiSchema: string | null | undefined;
      };
    } | null | undefined;
    readonly order: number | null | undefined;
    readonly templateType: string | null | undefined;
    readonly userType: string | null | undefined;
    readonly znglyContents: ReadonlyArray<{
      readonly author?: {
        readonly node: {
          readonly id: string;
          readonly name: string | null | undefined;
          readonly slug: string | null | undefined;
          readonly username: string | null | undefined;
        };
      } | null | undefined;
      readonly databaseId?: number;
      readonly id?: string;
      readonly link?: string | null | undefined;
      readonly searchResults?: {
        readonly extractiveAnswers: ReadonlyArray<{
          readonly content: string | null | undefined;
          readonly pageNumber: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly snippets: ReadonlyArray<{
          readonly snippet: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly status?: string | null | undefined;
      readonly statusSettings?: {
        readonly approved: {
          readonly id: string | null | undefined;
          readonly timestamp: string | null | undefined;
          readonly user: {
            readonly name: string | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly stateWhenApproved: {
          readonly status: PostStatusEnum | null | undefined;
          readonly uiPermission: {
            readonly type: StatusUiPermissionEnum | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly status: PostStatusEnum | null | undefined;
        readonly uiPermission: {
          readonly type: StatusUiPermissionEnum | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly title?: string | null | undefined;
      readonly znglyContent?: {
        readonly aiSummary: string | null | undefined;
        readonly contentEmbedHtml: string | null | undefined;
        readonly contentFile: {
          readonly mediaDetails: {
            readonly sizes: ReadonlyArray<{
              readonly name: string | null | undefined;
              readonly sourceUrl: string | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly mediaItemUrl: string | null | undefined;
        } | null | undefined;
        readonly contentLink: string | null | undefined;
        readonly contentMediaName: string | null | undefined;
        readonly contentMediaType: string | null | undefined;
        readonly ctaLink: string | null | undefined;
        readonly ctaName: string | null | undefined;
        readonly featuredImageFile: {
          readonly mediaDetails: {
            readonly sizes: ReadonlyArray<{
              readonly name: string | null | undefined;
              readonly sourceUrl: string | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly mediaItemUrl: string | null | undefined;
        } | null | undefined;
        readonly featuredImageLink: string | null | undefined;
        readonly form: {
          readonly node: {
            readonly content: string | null | undefined;
            readonly id: string;
            readonly imageUrl: string | null | undefined;
            readonly marketingConsent: boolean | null | undefined;
            readonly metadata: {
              readonly cookieExpiration: string | null | undefined;
              readonly formStyle: FormMetadataStyleEnum | null | undefined;
              readonly formTemplate: FormMetadataTemplateEnum | null | undefined;
              readonly submitSuccessText: string | null | undefined;
            } | null | undefined;
            readonly password: boolean | null | undefined;
            readonly schema: string | null | undefined;
            readonly title: string;
            readonly uiSchema: string | null | undefined;
          };
        } | null | undefined;
        readonly htmlDesc: string | null | undefined;
        readonly shortText: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "Znglist_Fragment";
};
export type Znglist_Fragment$key = {
  readonly " $data"?: Znglist_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"Znglist_Fragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "NodeWithAuthorToUserConnectionEdge",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "UIPermission",
  "kind": "LinkedField",
  "name": "uiPermission",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "StatusSettings",
  "kind": "LinkedField",
  "name": "statusSettings",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StateWhenApproved",
      "kind": "LinkedField",
      "name": "stateWhenApproved",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        (v7/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ApprovedState",
      "kind": "LinkedField",
      "name": "approved",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timestamp",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "mediaItemUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "MediaDetails",
    "kind": "LinkedField",
    "name": "mediaDetails",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MediaSize",
        "kind": "LinkedField",
        "name": "sizes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceUrl",
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v11 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Form",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "schema",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uiSchema",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FormMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formStyle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "formTemplate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cookieExpiration",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "submitSuccessText",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "marketingConsent",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "password",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "imageUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Znglist_Fragment",
  "selections": [
    (v0/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    (v2/*: any*/),
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Znglist_Znglist",
      "kind": "LinkedField",
      "name": "znglist",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "order",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "znglyContents",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "databaseId",
                  "storageKey": null
                },
                (v3/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v8/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AiSearchResults",
                  "kind": "LinkedField",
                  "name": "searchResults",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Snippet",
                      "kind": "LinkedField",
                      "name": "snippets",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "snippet",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ExtractiveAnswer",
                      "kind": "LinkedField",
                      "name": "extractiveAnswers",
                      "plural": true,
                      "selections": [
                        (v9/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "pageNumber",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ZnglyVideo_Znglycontent",
                  "kind": "LinkedField",
                  "name": "znglyContent",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "aiSummary",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "ctaLink",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "ctaName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contentMediaType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contentLink",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contentEmbedHtml",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contentMediaName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MediaItem",
                      "kind": "LinkedField",
                      "name": "contentFile",
                      "plural": false,
                      "selections": (v10/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "featuredImageLink",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MediaItem",
                      "kind": "LinkedField",
                      "name": "featuredImageFile",
                      "plural": false,
                      "selections": (v10/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "shortText",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "htmlDesc",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ZnglyVideo_ZnglycontentToFormConnectionEdge",
                      "kind": "LinkedField",
                      "name": "form",
                      "plural": false,
                      "selections": (v11/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "ZnglyVideo",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Znglist_ZnglistToFormConnectionEdge",
          "kind": "LinkedField",
          "name": "form",
          "plural": false,
          "selections": (v11/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Znglist",
  "abstractKey": null
};
})();

(node as any).hash = "468a8dc57a4b2054f63aa0842f73b0c9";

export default node;
